import MDialog from './MDialog';

export default MDialog;
